import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { Infographic } from './infographic.model';

const axios = useAxios();

export interface InfographicService {
  Fetch: () => Promise<AxiosResponse<Infographic[]>>;
}

const Fetch = (): Promise<AxiosResponse<Infographic[]>> =>
  axios.Get<Infographic[]>('api/infographics');

export default { Fetch } as InfographicService;
